import React, { useEffect, useState } from "react";

const useLoginStatus = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [redirectAfterLogin, setRedirectAfterLogin] = useState("");

  useEffect(() => {
    const token = window.localStorage.getItem("token");
    const localRedirect = window.localStorage.getItem("redirectAfterLogin");
    setRedirectAfterLogin(localRedirect);
    if (token) {
      setIsLoggedIn(true);
    }
    setLoading(false);
  }, []);

  const saveRedirectLocation = (pathname) => {
    window.localStorage.setItem("redirectAfterLogin", pathname);
  };

  const deleteRedirectLocation = () => {
    window.localStorage.removeItem("redirectAfterLogin");
  };

  return {
    loading,
    isLoggedIn,
    redirectAfterLogin,
    saveRedirectLocation,
    deleteRedirectLocation,
  };
};

export default useLoginStatus;
